<ctv-toolbar [pageTitle]="'Demand connections '" *ngIf="!dpId">
  <div toolbar-actions>
    <button *csHasPermission="RolePermission.CONNECTION_CREATE" (click)="createConnection()" mat-flat-button color="primary" class="iconed">
      <i class="fal fa-plus-circle"></i>
      <span>New connection</span>
    </button>
  </div>
</ctv-toolbar>
<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <mat-card>
          <mat-card-header>
            <mat-card-title>Demand connections list</mat-card-title>
            <div class="mat-card-header-buttons" *csHasPermission="RolePermission.CONNECTION_CREATE">
              <button *ngIf="dpId" mat-flat-button color="primary"
                      (click)="createConnection()" class="mat-elevation-z0 iconed">
                <i class="fas fa-plus" aria-hidden="true"></i>
                <span>Add new connection</span>
              </button>
            </div>
            <div class="mat-card-header-status">
              <ctv-status-box *ngFor="let item of statusCounts" (statusClicked)="!loading && filterByStatus($event)"
                              [status]="setConnectionStatus(item)" [activeBox]="isStatusFilterSelected(item.status)">
              </ctv-status-box>
            </div>
            <div class="mat-card-header-search">
              <mat-form-field class="header-form-field mr-lg-n3 border-right-0" floatLabel="never">
                <input matInput [value]="filter.name||''" [formControl]="nameControl" placeholder="search">
                <i class="far fa-search" matSuffix></i>
              </mat-form-field>
            </div>
          </mat-card-header>
          <mat-card-content class="mat-card-content--full">
            <div class="data-loader" [hidden]="!loading">
              <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="30">
              </mat-spinner>
            </div>
            <div class="data-alert" [hidden]="loading || (dataSource.data && dataSource.data.length)">
              No data to show
            </div>
            <div class="table-scroll-wrapper" [hidden]="loading || !dataSource.data || !dataSource.data.length">
              <mat-table #table [dataSource]="dataSource" matSort [matSortActive]="filter.sortProperty" [matSortDirection]="filter.sortDirection.toLowerCase()">

                <ng-container matColumnDef="name">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
                  <mat-cell *matCellDef="let element">

                    <a *csHasPermission="RolePermission.CONNECTION_EDIT" class="link" [routerLink]="'/connections/' + element.id + '/demand/' + element.demandPartner.id + '/details/overview'">
                      <i class="fas fa-circle status-circle" ngClass="text-{{ConnectionStatusColorMap[element.status]}}"></i>
                      {{element.name}}
                    </a>
                    <span *csHasNoPermission="RolePermission.CONNECTION_EDIT">
                      {{element.name}}
                    </span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="dpDisplayName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="demandPartner.displayName">DP</mat-header-cell>
                  <mat-cell *matCellDef="let element">

                    <span>{{element.demandPartner.displayName}}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="placements">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="placementCnt">Placements</mat-header-cell>
                  <mat-cell *matCellDef="let element">

                    <button mat-button color="primary" [disabled]="element.placementCnt === 0"
                      (click)="openPlacementDialog(element)">{{element.placementCnt}}</button>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="sellerDomain">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="schainAsi">Seller domain (ASI)</mat-header-cell>
                  <mat-cell *matCellDef="let element">

                    <span>{{element.schainAsi}}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="integrationType">
                  <mat-header-cell *matHeaderCellDef mat-sort-header mat-sort-header>Integration type</mat-header-cell>
                  <mat-cell *matCellDef="let element">

                    <span>{{integrationTypeLabels[element.integrationType]}}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="duplication">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="duplicateDpConnection">Duplication</mat-header-cell>
                  <mat-cell *matCellDef="let element">

                    <i class="fas fa-check text-success" *ngIf="element.duplicateDpConnection"></i>
                    <i class="far fa-times text-muted" *ngIf="!element.duplicateDpConnection"></i>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="added">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="createdOn">Added</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span [matTooltip]="element.createdOn | date: 'HH:mm' : ''">{{element.createdOn |
                      date:'MM/dd/yyyy'}}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="notes">
                  <mat-header-cell *matHeaderCellDef>Note</mat-header-cell>
                  <mat-cell *matCellDef="let element">

                    <i *ngIf="element.notes" class='fal fa-info-circle text-info' matTooltip="{{element.notes}}"></i>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let element">

                    <button mat-icon-button disableRipple="true" (click)="$event.stopPropagation()"
                      [matMenuTriggerFor]="menu">
                      <i class="far fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item *csHasPermission="RolePermission.CONNECTION_EDIT" matTooltip="Edit" (click)="editConnection(element)">
                        <i class="far fa-edit"></i> Edit
                      </button>
                      <button mat-menu-item *csHasPermission="RolePermission.CONNECTION_DUPLICATE" matTooltip="Duplicate" (click)="duplicateConnection(element)">
                        <i class="far fa-copy"></i> Duplicate
                      </button>
                    </mat-menu>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns"></mat-row>
              </mat-table>
            </div>
          </mat-card-content>
          <mat-card-footer [hidden]="loading || !dataSource.data || !dataSource.filteredData.length">
            <mat-paginator #paginator [pageSize]="filter.size" [pageSizeOptions]="[5, 10, 25, 50, 100]">
            </mat-paginator>
          </mat-card-footer>
        </mat-card>
      </div>
    </div>
  </div>
</div>
